// 애플리케이션 버전 정보 (버전 관리 단일 출처).
// 릴리스 시 이 값을 갱신하고 동일 버전으로 git 태그를 붙인다(예: v0.1.0).
export const APP_VERSION = 'v1.0.0';
export const COMPANY = 'CPLABS inc.';
